// extracted by mini-css-extract-plugin
export default {"newDependency":"AddNewDependencyWidget_newDependency__ElH2F","newDependencyContent":"AddNewDependencyWidget_newDependencyContent__25jYY"};